module.exports = __webpack_public_path__ + "img/bg03_1.fb729489.png";